import React, { useEffect, useState } from 'react';
import Logo from '../assets/Logo.png';
import Button from './Button';

const Navbar = () => {
  const [activeSection, setActiveSection] = useState('');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const sections = document.querySelectorAll('section');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
          }
        });
      },
      { threshold: 0.4 }
    );

    sections.forEach((section) => {
      observer.observe(section);
    });

    return () => {
      sections.forEach((section) => {
        observer.unobserve(section);
      });
    };
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <div className='w-full h-[70px] lg:h-[90px] p-4 px-6 lg:px-10 shadow fixed bg-white z-40 top-0 left-0 flex justify-between items-center'>
      <a href='#hero' onClick={closeMobileMenu}>
        <img src={Logo} alt='logo' className='w-[70%] lg:w-[85%]' />
      </a>

      {/* Desktop Menu */}
      <ul className='hidden lg:flex items-center gap-x-4 lg:gap-x-6 navlink'>
        <li>
          <a href='#aboutUs' className={activeSection === 'aboutUs' ? 'active' : ''}>
            About Us
          </a>
        </li>
        <li>
          <a href='#building' className={activeSection === 'building' ? 'active' : ''}>
           Our Buildings
          </a>
        </li>
        <li>
          <a href='#team' className={activeSection === 'team' ? 'active' : ''}>
            Team
          </a>
        </li>
        <li>
          <a href='#project' className={activeSection === 'project' ? 'active' : ''}>
            Project
          </a>
        </li>
        <li>
          <a href='#contact' className={activeSection === 'contact' ? 'active' : ''}>
            Contact
          </a>
        </li>
      </ul>
      <a href='#donate'>
      <Button content={'Donate'} />
      </a>
      

      {/* Mobile Menu Toggle */}
      <div className='lg:hidden ml-1'>
        <button onClick={toggleMobileMenu} className='text-black'>
          <span className='material-icons'>{isMobileMenuOpen ? 'close' : 'menu'}</span>
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className='absolute top-[70px] left-0 w-full bg-white shadow-lg z-30 flex flex-col items-center gap-y-4 py-4'>
          <a href='#aboutUs' className={activeSection === 'aboutUs' ? 'active' : ''} onClick={closeMobileMenu}>
            About Us
          </a>
          <a href='#building' className={activeSection === 'building' ? 'active' : ''} onClick={closeMobileMenu}>
          Our Buildings
          </a>
          <a href='#team' className={activeSection === 'team' ? 'active' : ''} onClick={closeMobileMenu}>
            Team
          </a>
          <a href='#project' className={activeSection === 'project' ? 'active' : ''} onClick={closeMobileMenu}>
            Project
          </a>
          <a href='#contact' className={activeSection === 'contact' ? 'active' : ''} onClick={closeMobileMenu}>
            Contact
          </a>
          {/* <Button content={'Donate'} style={''} /> */}
        </div>
      )}
    </div>
  );
};

export default Navbar;